import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-recurrent-pregnancy-loss',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './recurrent-pregnancy-loss.component.html',
  styleUrl: './recurrent-pregnancy-loss.component.scss'
})
export class RecurrentPregnancyLossComponent implements OnInit {
  constructor(private route: Router, private metaService: Meta,
    private titleService: Title,
) { }

  ngOnInit(): void {
    
        this.titleService.setTitle('Recurrent Pregnancy Loss Treatment in Kannur | Ncare IVF Centre');
this.metaService.updateTag({
  name: 'description',
  content: 'Facing repeated miscarriages? Ncare IVF Centre in Kannur provides advanced evaluation and compassionate care for Recurrent Pregnancy Loss to support a healthy, successful pregnancy.'
});

this.metaService.updateTag({
  name: 'keywords',
  content: 'Recurrent Pregnancy Loss, Recurrent pregnancy loss treatment, Recurrent pregnancy loss treatment in Kannur'
});

this.metaService.updateTag({
  property: 'og:title',
  content: 'Recurrent Pregnancy Loss Treatment in Kannur | Ncare IVF Centre'
});

this.metaService.updateTag({
  property: 'og:description',
  content: 'Facing repeated miscarriages? Ncare IVF Centre in Kannur provides advanced evaluation and compassionate care for Recurrent Pregnancy Loss to support a healthy, successful pregnancy.'
});
  }

  contactus() {
    this.route.navigate(['/contact-us']);
  }
  activeIndex: number | null = null;

  causes = [
    {
      title: 'Genetic Abnormalities',
      points: [
        'Chromosomal abnormalities in embryos or parents can lead to pregnancy loss.',
        'Conditions such as balanced translocations or aneuploidy may affect embryo viability.',
        'Preimplantation Genetic Testing (PGT) can help identify genetically normal embryos for transfer.'
      ]
    },
    {
      title: 'Uterine Abnormalities',
      points: [
        'Structural defects in the uterus like fibroids, polyps, septa, or scarring can cause miscarriage.',
        'Hysteroscopy and 3D ultrasound help detect and correct these abnormalities.'
      ]
    },
    {
      title: 'Hormonal Imbalances',
      points: [
        'Conditions like PCOS, hypothyroidism, and luteal phase defects can impact pregnancy.',
        'Hormonal therapy and personalized treatment can restore balance and support conception.'
      ]
    },
    {
      title: 'Immune System Disorders',
      points: [
        'Autoimmune responses may cause the body to reject the embryo.',
        'Immunotherapy and IVIG therapy can help regulate immune tolerance.'
      ]
    },
    {
      title: 'Blood Clotting Disorders (Thrombophilia)',
      points: [
        'Conditions like APS and Factor V Leiden mutation can restrict oxygen to the baby.',
        'Low-dose aspirin and heparin improve blood flow and reduce risk of miscarriage.'
      ]
    },
    {
      title: 'Infections',
      points: [
        'Bacterial and viral infections can increase miscarriage risk.',
        'Screening and antibiotics can prevent complications.'
      ]
    },
    {
      title: 'Lifestyle Factors',
      points: [
        'Smoking, alcohol, obesity, poor diet, and stress affect pregnancy outcomes.',
        'Holistic care and lifestyle changes improve reproductive health and success.'
      ]
    }
  ];

  toggle(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
}





